export const getters = {
    authenticated(state) {
        return state.authenticated;
    },
    countries(state) {
        return state.countries;
    },
    freeze(state) {
        return state.freeze;
    },
    cartIsOrderingDisabled(state) {
        return !state.authenticated || state.freeze;
    },
    cartIsEmpty(state) {
        return state.cartData.items === null || state.cartData.items.length === 0
    },
    cartOrderItemCount(state) {
        return state.cartData.items.reduce((sum, item) => sum + item.items.length, 0);
    },
    cartShowFanboxOption(state, getters) {
        return getters.cartFanboxList.length > 0 && getters.cartSelectedFanboxItems.length >= state.cartFanboxThreshold;// Deaktiviert die Fanbox wenn bereits ein Fanbox-Artikel im Warenkorb liegt: && !getters.cartGetCartDataItemForOrdernumber(window.cartdata.fanboxId);
    },
    cartFaecherItems(state) {
        if (state.cartData && state.cartData.items) {
            const faecher = state.cartData.items.filter(section => section.category === 'faecher')

            if (faecher.length) {
                return faecher[0]['items'] || []
            }
        }
        return []
    },
    cartSelectedFanboxItems(state, getters) {
        return getters.cartFaecherItems.filter(item => getters.cartFanboxList.includes(item.ordernumber))
    },
    cartSelectedFanboxList(state, getters) {
        return getters.cartSelectedFanboxItems.map(item => item.ordernumber);
    },
    cartUnselectedFanboxItems(state, getters) {
        return state.cartFanboxItems.filter(item => !getters.cartSelectedFanboxList.includes(item.ordernumber))
    },
    cartUnselectedFanboxList(state, getters) {
        return getters.cartUnselectedFanboxItems.map(item => item.ordernumber)
    },
    cartSelectedNonFanboxItems(state, getters) {
        return getters.cartFaecherItems.filter(item => !getters.cartFanboxList.includes(item.ordernumber))
    },
    cartFanboxList(state) {
        return state.cartFanboxItems.map(item => item.ordernumber)
    },
    cartCheckErrorItem: (state) => (pim_id) => {
        return state.cartErrorItems.indexOf(pim_id) !== -1;
    },
    cartGetCartOrderQuantityForPimId: (state) => (pim_id) => {
        return state.cartOrderQuantity[pim_id]
    },
    cartGetCartDataItemForPimId: (state) => (pim_id) => {
        return state.cartData.items.reduce((prev, category) => prev || category.items.find(item => item.pim_id === pim_id), undefined)
    },
    cartGetCartDataItemForOrdernumber: (state) => (ordernumber) => {
        return state.cartData.items.reduce((prev, category) => prev || category.items.find(item => item.ordernumber === ordernumber), undefined)
    }
};
